import { render, staticRenderFns } from "./repairDetail.vue?vue&type=template&id=8ac24462&scoped=true&"
import script from "./repairDetail.vue?vue&type=script&lang=js&"
export * from "./repairDetail.vue?vue&type=script&lang=js&"
import style0 from "./repairDetail.vue?vue&type=style&index=0&id=8ac24462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac24462",
  null
  
)

export default component.exports